<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/McrIqQ/tc-custom/9781571318763.jpg?1705012687097" alt="This image is the cover for the book Hundred Grasses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hundred Grasses
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Beautiful and necessary.” —DAN BEACHY-QUICK</b></p><p>Shimmering and formally precise, the poems of this debut collection “fuse absence and presence in lines full of a feeling that has no opposite” (Brian Teare).</p><p>These are poems written from the periphery of an open field, poems rooted in the flatlands and lowlands: the Midwestern lawns, lakes, and creeks of Leila Wilson’s childhood, and the farms, canals, and seascapes near her family home’s in Holland. “We wonder / what we’re not / in the field,” writes Wilson—and reading <i>The Hundred Grasses</i>, we too are made to wonder about both what is lacking and what fills the void. In these poems, the act of looking animates what is seemingly static. Stillness becomes not absence but fullness. Sounds are culled from empty spaces, giving shape to life’s silences. In the process of this hollowing out and filling up, <i>The Hundred Grasses</i> morphs into an extended and unforgettable investigation of longing and loss, love and doubt.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leila Wilson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37afc5c2